import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateUser, listUser } from "../../../redux/actions/userActions";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/EditOutlined";

import ConfirmDialog from "../../common/ConfirmDialog";

const User = (props) => {
    const { id, name, email, role, isActive } = props.user;
    const from = props.from;
    const orgId = props.organizationId;

    const dispatch = useDispatch();
    const [confirm, setConfirm] = useState(null); // { nextStatus: boolean } | null

    const applyStatusChange = () => {
        if (!confirm) return;
        const { nextStatus } = confirm;
        setConfirm(null);
        const obj = { id, isActive: nextStatus };
        dispatch(updateUser({ reqData: obj, orgId })).then(() => {
            dispatch(listUser(1, 20, "role", "", "", "", from, orgId));
        });
    };

    const fromOrgReadonly = from === "organization";

    return (
        <>
            <TableRow hover>
                <TableCell sx={{ fontWeight: 600 }}>{name}</TableCell>
                <TableCell sx={{ color: "text.secondary" }}>{email}</TableCell>
                <TableCell>
                    <Chip label={role} size="small" variant="outlined" />
                </TableCell>
                <TableCell>
                    {fromOrgReadonly ? (
                        <Chip
                            label={isActive ? "Active" : "Inactive"}
                            size="small"
                            color={isActive ? "success" : "default"}
                            variant={isActive ? "filled" : "outlined"}
                        />
                    ) : (
                        <Chip
                            label={isActive ? "Active" : "Inactive"}
                            size="small"
                            color={isActive ? "success" : "default"}
                            variant={isActive ? "filled" : "outlined"}
                            onClick={() => setConfirm({ nextStatus: !isActive })}
                            sx={{ cursor: "pointer" }}
                        />
                    )}
                </TableCell>
                {!fromOrgReadonly && (
                    <TableCell align="center">
                        <IconButton component={RouterLink} to={`/user/edit/${id}`} title="Edit user" size="small">
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </TableCell>
                )}
            </TableRow>

            <ConfirmDialog
                open={Boolean(confirm)}
                title={confirm?.nextStatus ? `Activate ${name}?` : `Deactivate ${name}?`}
                body={
                    confirm?.nextStatus
                        ? `${name} will regain access to this organization's apps and builds.`
                        : `${name} will lose access to this organization's apps and builds until reactivated.`
                }
                confirmLabel={confirm?.nextStatus ? "Activate" : "Deactivate"}
                confirmColor={confirm?.nextStatus ? "primary" : "error"}
                onCancel={() => setConfirm(null)}
                onConfirm={applyStatusChange}
            />
        </>
    );
};

export default User;
